// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.download-sidebar {
  padding-left: 3rem !important;
  padding-right: 3rem !important;
}
.download-sidebar h2 {
  margin-bottom: 2.4rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/components/Sidebars/DownloadSidebar/index.scss"],"names":[],"mappings":"AAAA;EACE,6BAAA;EACA,8BAAA;AACF;AACE;EACE,qBAAA;AACJ","sourcesContent":[".download-sidebar {\n  padding-left: 3rem !important;\n  padding-right: 3rem !important;\n\n  h2 {\n    margin-bottom: 2.4rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
